import { CloseEye, OpenEye } from '@/components/Media/Icon';
import { colors } from '@/styles/theme/constants';
import { InputGroup, InputRightAddon, useBoolean } from '@chakra-ui/react';
import { type FC } from 'react';
import type { InputPassswordProps } from './types';
import { FormControl } from '../FormControl';
import { FormLabel } from '../FormLabel';
import { FormErrorMessage } from '../FormErrorMessage';
import { Input } from '../Input';

export const InputPassword: FC<InputPassswordProps> = ({ label, errorMessage, formControlProps, ...props }) => {
  const [ isVisible, setIsVisible ] = useBoolean(false);

  return (
    <FormControl isInvalid={!!errorMessage} {...formControlProps}>
      <InputGroup bg="shade09" borderRadius="8px">
        <Input
          translate="no"
          type={isVisible ? 'text' : 'password'}
          borderRightRadius="0"
          {...props}
        />
        <FormLabel>{label}</FormLabel>
        <InputRightAddon
          as="button"
          type="button"
          bg="none"
          border={0}
          h="56px"
          onClick={setIsVisible.toggle}
          _focusVisible={{
            outline: 'none',
          }}
          mr={1}
        >
          {isVisible ? (
            <OpenEye fill={colors.shade02} />
          ) : (
            <CloseEye fill={colors.shade05} />
          )}
        </InputRightAddon>
      </InputGroup>
      {errorMessage && <FormErrorMessage>{errorMessage}</FormErrorMessage>}
    </FormControl>
  )
}
